import { useEffect, useState } from "react";
import SectionHeader from "@/components/SectionHeader";
import ServerCard from "@/components/ServerCard";
import IPPill from "@/components/IPPill";
import { fetchServers } from "@/lib/api";

export default function Servers() {
  const [servers, setServers] = useState([]);
  useEffect(() => { fetchServers().then(setServers).catch(() => {}); }, []);
  return (
    <div className="pt-32 pb-24 px-4 sm:px-6" data-testid="page-servers">
      <div className="max-w-7xl mx-auto">
        <SectionHeader eyebrow="Servers" title="Choose Your World" subtitle="Every server on the LostDC Network is built with unique mechanics, custom systems and dedicated moderation." />
        <div className="mb-10"><IPPill /></div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {servers.map((s, i) => <ServerCard key={s.id} server={s} index={i} />)}
        </div>

        <div className="mt-20 grid md:grid-cols-2 gap-6">
          {servers.map((s) => (
            <div key={s.key} className="rounded-2xl glass p-6" data-testid={`server-howto-${s.key}`}>
              <div className="text-[10px] uppercase tracking-[0.3em] text-[#FFBF00]">How to Join</div>
              <div className="font-hero text-2xl mt-1">{s.name}</div>
              <ol className="mt-4 space-y-2 text-sm text-white/70 list-decimal list-inside">
                {s.connection_steps.map((step, idx) => <li key={idx}>{step}</li>)}
              </ol>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
